var moduleMap = {
	"./noop": function() {
		return __webpack_require__.e(/* __federation_expose_noop */ 5120).then(function() { return function() { return (__webpack_require__(65557)); }; });
	},
	"./react": function() {
		return __webpack_require__.e(/* __federation_expose_react */ 1933).then(function() { return function() { return (__webpack_require__(79474)); }; });
	},
	"./react-dom": function() {
		return __webpack_require__.e(/* __federation_expose_react_dom */ 8884).then(function() { return function() { return (__webpack_require__(41615)); }; });
	},
	"./next/router": function() {
		return __webpack_require__.e(/* __federation_expose_next__router */ 5286).then(function() { return function() { return (__webpack_require__(40664)); }; });
	}
};
var get = function(module, getScope) {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(function() {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = function(shareScope, initScope, remoteEntryInitOptions) {
	return __webpack_require__.federation.bundlerRuntime.initContainerEntry({	webpackRequire: __webpack_require__,
		shareScope: shareScope,
		initScope: initScope,
		remoteEntryInitOptions: remoteEntryInitOptions,
		shareScopeKey: "default"
	})
};
__webpack_require__(69516)

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: function() { return get; },
	init: function() { return init; }
});